import { render, staticRenderFns } from "./Gedit.vue?vue&type=template&id=6009b36b&"
import script from "./Gedit.vue?vue&type=script&lang=js&"
export * from "./Gedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports